(function () {
  console.log("HELLO WORLD FROM REDIRECT");

  // Check if we've already redirected to prevent loops
  const hasRedirected = sessionStorage.getItem("hasRedirected");
  if (hasRedirected) {
    console.log("Already redirected once, preventing loop");
    sessionStorage.removeItem("hasRedirected");
    sessionStorage.removeItem("redirectTo");
    return;
  }

  const redirectTo = sessionStorage.getItem("redirectTo");
  console.log("redirectTo =>", redirectTo);
  const checkoutToken = sessionStorage.getItem("checkout_token");

  if (!redirectTo) {
    console.log("No redirect specified");
    return;
  }

  if (redirectTo) {
    console.log("checkout token", checkoutToken);
    if (checkoutToken) {
      console.log(
        "redirecting to",
        `${redirectTo}&checkout_token=${checkoutToken}`
      );
      window.location.href = `${redirectTo}&checkout_token=${checkoutToken}`;
    }

    console.log("redirecting to:", redirectTo);
    window.location.href = redirectTo;
  }
})();
